import React, { useState, useEffect } from "react";
import Home from "./home";
import About from "./about";
import OTMMViewer from "./otmmViewer";
import UserPermissions from "./UserPermissions";
import LegalBillingReport from "./LegalBillingReport";
import BillingSummaryByYear from "./BillingSummaryByYear";

function getPathname() {
    return window.location.pathname;
}

const AppRoutes = () => {
    const [pathname, setPathname] = useState(getPathname);

    useEffect(() => {
        const onLocationChange = () => setPathname(getPathname());
        window.addEventListener("popstate", onLocationChange);

        const origPushState = window.history.pushState;
        const origReplaceState = window.history.replaceState;
        window.history.pushState = function () {
            origPushState.apply(this, arguments);
            onLocationChange();
        };
        window.history.replaceState = function () {
            origReplaceState.apply(this, arguments);
            onLocationChange();
        };

        return () => {
            window.removeEventListener("popstate", onLocationChange);
            window.history.pushState = origPushState;
            window.history.replaceState = origReplaceState;
        };
    }, []);

    if (pathname === "/about") return <About />;
    if (pathname === "/user-permissions") return <UserPermissions />;
    if (pathname === "/reports/billing/summary-by-year") return <BillingSummaryByYear />;
    if (pathname === "/reports/billing/by-practice-area") return <LegalBillingReport />;
    if (pathname.startsWith("/ui/")) return <OTMMViewer />;
    if (pathname === "/home" || pathname === "/") return <Home />;

    return null;
};

export default AppRoutes;
